import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayVoteThumbIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 8.74999H12.86L13.4 4.99999C13.68 3.33999 12.26 1.70999 10.58 1.74999C9.32 1.74999 8.19 2.59999 7.84 3.80999L6.43 8.74999H2C1.04 8.74999 0.25 9.53999 0.25 10.5V20.5C0.25 21.46 1.04 22.25 2 22.25H19.65C20.78 22.25 21.78 21.57 22.2 20.52L22.98 18.56C23.49 17.28 23.75 15.94 23.75 14.57V11.5C23.75 9.97999 22.52 8.74999 21 8.74999ZM6.25 20.75H2C1.86 20.75 1.75 20.64 1.75 20.5V10.5C1.75 10.36 1.86 10.25 2 10.25H6.25V20.75ZM22.25 14.57C22.25 15.75 22.03 16.91 21.59 18.01L20.81 19.97C20.62 20.45 20.16 20.76 19.65 20.76H7.75V9.60999L9.29 4.22999C9.45 3.64999 9.99 3.24999 10.58 3.24999C11.38 3.22999 12.04 3.99999 11.91 4.78999L11.25 9.39999C11.18 9.83999 11.55 10.27 11.99 10.26H20.99C21.68 10.26 22.24 10.82 22.24 11.51V14.58L22.25 14.57Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayVoteThumbIcon.displayName = 'PayVoteThumbIcon';
